import { GridApi } from 'ag-grid-community';
import { FaultAuditReference, FaultAuditUserSelect } from 'components/selects/FaultAuditUserSelect';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

interface FilterProps {
  api: GridApi;
  onChange?: FilterChangeCallback;
}
interface Config {
  reference: FaultAuditReference;
}

/** Scoped select filter for one historical resolution reference. */
export default function FaultAuditUserSelectFilter({ reference, api, onChange }: FilterProps & Config) {
  const [value, setValue] = useFilterValue({ api, filterKey: `fixed.${reference}.userId`, onChange });
  return (
    <FaultAuditUserSelect
      reference={reference}
      lazyLoad
      clearable
      size="sm"
      w="100%"
      placeholder="Všetci používatelia"
      value={String(value)}
      onChange={setValue}
    />
  );
}
FaultAuditUserSelectFilter.configure = (config: Config) => (props: FilterProps) =>
  <FaultAuditUserSelectFilter {...config} {...props} />;
